"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var index_exports = {};
__export(index_exports, {
  AccelerationCode: () => AccelerationCode,
  AngleCode: () => AngleCode,
  AreaCode: () => AreaCode,
  CurrentCode: () => CurrentCode,
  DensityCode: () => DensityCode,
  DurationCode: () => DurationCode,
  ForceCode: () => ForceCode,
  FrequencyCode: () => FrequencyCode,
  LengthCode: () => LengthCode,
  LinearFrequencyCode: () => LinearFrequencyCode,
  LinearPressureCode: () => LinearPressureCode,
  PressureCode: () => PressureCode,
  RotationalFrequencyCode: () => RotationalFrequencyCode,
  SpeedCode: () => SpeedCode,
  TemperatureCode: () => TemperatureCode,
  TorsionCode: () => TorsionCode,
  UnitSystem: () => import_echain_shared_i18n2.UnitSystem,
  UnitToUnitSystemCategory: () => UnitToUnitSystemCategory,
  WeightCode: () => WeightCode,
  WeightPerLengthCode: () => WeightPerLengthCode,
  getFlatUnitToUnitSystemDefinition: () => getFlatUnitToUnitSystemDefinition,
  getSchemaUnitCode: () => getSchemaUnitCode,
  getUnitCodeForUnitSystem: () => getUnitCodeForUnitSystem,
  getUnitLabel: () => getUnitLabel,
  getUnitLabelForUnitSystem: () => getUnitLabelForUnitSystem,
  getUnitSystemDefinitionItem: () => getUnitSystemDefinitionItem
});
module.exports = __toCommonJS(index_exports);
var import_echain_shared_i18n2 = require("@igus/echain-shared-i18n");

// src/unitCodeDefinitions.ts
var import_echain_shared_i18n = require("@igus/echain-shared-i18n");
var AngleCode;
(function(AngleCode2) {
  AngleCode2["DEGREE"] = "DEGREE";
  AngleCode2["MINUTE"] = "MINUTE";
  AngleCode2["SECOND"] = "SECOND";
  AngleCode2["GON"] = "GON";
  AngleCode2["MIL"] = "MIL";
  AngleCode2["REVOLUTION"] = "REVOLUTION";
  AngleCode2["RADIAN"] = "RADIAN";
})(AngleCode || (AngleCode = {}));
var DensityCode;
(function(DensityCode2) {
  DensityCode2["GRAM_PER_CUBIC_CENTIMETER"] = "GRAM_PER_CUBIC_CENTIMETER";
  DensityCode2["POUND_PER_CUBIC_INCH"] = "POUND_PER_CUBIC_INCH";
})(DensityCode || (DensityCode = {}));
var TemperatureCode;
(function(TemperatureCode2) {
  TemperatureCode2["CELSIUS"] = "CELSIUS";
  TemperatureCode2["FAHRENHEIT"] = "FAHRENHEIT";
})(TemperatureCode || (TemperatureCode = {}));
var LengthCode;
(function(LengthCode2) {
  LengthCode2["METER"] = "METER";
  LengthCode2["FEET"] = "FEET";
  LengthCode2["MILLIMETER"] = "MILLIMETER";
  LengthCode2["INCH"] = "INCH";
  LengthCode2["KILOMETER"] = "KILOMETER";
})(LengthCode || (LengthCode = {}));
var AreaCode;
(function(AreaCode2) {
  AreaCode2["SQUARE_MILLIMETER"] = "SQUARE_MILLIMETER";
  AreaCode2["SQUARE_INCH"] = "SQUARE_INCH";
  AreaCode2["CUBIC_MILLIMETER"] = "CUBIC_MILLIMETER";
  AreaCode2["CUBIC_INCH"] = "CUBIC_INCH";
})(AreaCode || (AreaCode = {}));
var WeightCode;
(function(WeightCode2) {
  WeightCode2["KILOGRAM"] = "KILOGRAM";
  WeightCode2["POUND"] = "POUND";
})(WeightCode || (WeightCode = {}));
var WeightPerLengthCode;
(function(WeightPerLengthCode2) {
  WeightPerLengthCode2["KILOGRAM_PER_KILOMETER"] = "KILOGRAM_PER_KILOMETER";
  WeightPerLengthCode2["POUND_PER_THOUSAND_FOOT"] = "POUND_PER_THOUSAND_FOOT";
})(WeightPerLengthCode || (WeightPerLengthCode = {}));
var SpeedCode;
(function(SpeedCode2) {
  SpeedCode2["METER_PER_SECOND"] = "METER_PER_SECOND";
  SpeedCode2["FOOT_PER_SECOND"] = "FOOT_PER_SECOND";
})(SpeedCode || (SpeedCode = {}));
var AccelerationCode;
(function(AccelerationCode2) {
  AccelerationCode2["METER_PER_SQUARE_SECOND"] = "METER_PER_SQUARE_SECOND";
  AccelerationCode2["FEET_PER_SQUARE_SECOND"] = "FEET_PER_SQUARE_SECOND";
})(AccelerationCode || (AccelerationCode = {}));
var TorsionCode;
(function(TorsionCode2) {
  TorsionCode2["DEGREE_PER_METER"] = "DEGREE_PER_METER";
  TorsionCode2["DEGREE_PER_FOOT"] = "DEGREE_PER_FOOT";
})(TorsionCode || (TorsionCode = {}));
var ForceCode;
(function(ForceCode2) {
  ForceCode2["NEWTON"] = "NEWTON";
  ForceCode2["POUND_FORCE"] = "POUND_FORCE";
})(ForceCode || (ForceCode = {}));
var PressureCode;
(function(PressureCode2) {
  PressureCode2["MEGAPASCAL"] = "MEGAPASCAL";
  PressureCode2["PSI"] = "PSI";
})(PressureCode || (PressureCode = {}));
var DurationCode;
(function(DurationCode2) {
  DurationCode2["MINUTE"] = "MINUTE";
  DurationCode2["SECOND"] = "SECOND";
})(DurationCode || (DurationCode = {}));
var RotationalFrequencyCode;
(function(RotationalFrequencyCode2) {
  RotationalFrequencyCode2["REVOLUTION_PER_MINUTE"] = "REVOLUTION_PER_MINUTE";
  RotationalFrequencyCode2["REVOLUTION_PER_SECOND"] = "REVOLUTION_PER_SECOND";
  RotationalFrequencyCode2["ROTATIONAL_REVOLUTION_PER_MINUTE"] = "ROTATIONAL_REVOLUTION_PER_MINUTE";
})(RotationalFrequencyCode || (RotationalFrequencyCode = {}));
var FrequencyCode;
(function(FrequencyCode2) {
  FrequencyCode2["PER_MINUTE"] = "PER_MINUTE";
})(FrequencyCode || (FrequencyCode = {}));
var LinearPressureCode;
(function(LinearPressureCode2) {
  LinearPressureCode2["MEGAPASCAL_PER_METER_METER_PER_SECOND"] = "MEGAPASCAL_PER_METER_METER_PER_SECOND";
  LinearPressureCode2["POUND_FORCE_PER_SQUARE_INCH_FOOT_PER_MINUTE"] = "POUND_FORCE_PER_SQUARE_INCH_FOOT_PER_MINUTE";
})(LinearPressureCode || (LinearPressureCode = {}));
var LinearFrequencyCode;
(function(LinearFrequencyCode2) {
  LinearFrequencyCode2["STROKES_PER_MINUTE"] = "STROKES_PER_MINUTE";
  LinearFrequencyCode2["REVOLUTION_PER_MINUTE"] = "REVOLUTION_PER_MINUTE";
})(LinearFrequencyCode || (LinearFrequencyCode = {}));
var VoltageCode;
(function(VoltageCode2) {
  VoltageCode2["MILLIVOLT"] = "MILLIVOLT";
  VoltageCode2["CENTIVOLT"] = "CENTIVOLT";
  VoltageCode2["DECIVOLT"] = "DECIVOLT";
  VoltageCode2["VOLT"] = "VOLT";
  VoltageCode2["DEKAVOLT"] = "DEKAVOLT";
  VoltageCode2["HECTOVOLT"] = "HECTOVOLT";
  VoltageCode2["KILOVOLT"] = "KILOVOLT";
  VoltageCode2["volt_per_kilo_round_per_minute"] = "volt_per_kilo_round_per_minute";
})(VoltageCode || (VoltageCode = {}));
var CurrentCode;
(function(CurrentCode2) {
  CurrentCode2["MILLIAMPERE"] = "MILLIAMPERE";
  CurrentCode2["AMPERE"] = "AMPERE";
})(CurrentCode || (CurrentCode = {}));
var UnitToUnitSystemCategory;
(function(UnitToUnitSystemCategory2) {
  UnitToUnitSystemCategory2["SQUARE_AREA"] = "SQUARE_AREA";
  UnitToUnitSystemCategory2["CUBIC_AREA"] = "CUBIC_AREA";
  UnitToUnitSystemCategory2["DENSITY"] = "DENSITY";
  UnitToUnitSystemCategory2["TEMPERATURE"] = "TEMPERATURE";
  UnitToUnitSystemCategory2["LENGTH_METER_FEET"] = "LENGTH_METER_FEET";
  UnitToUnitSystemCategory2["LENGTH_MILLIMETER_INCH"] = "LENGTH_MILLIMETER_INCH";
  UnitToUnitSystemCategory2["WEIGHT"] = "WEIGHT";
  UnitToUnitSystemCategory2["WEIGHT_PER_LENGTH"] = "WEIGHT_PER_LENGTH";
  UnitToUnitSystemCategory2["SPEED"] = "SPEED";
  UnitToUnitSystemCategory2["ACCELERATION"] = "ACCELERATION";
  UnitToUnitSystemCategory2["FORCE"] = "FORCE";
  UnitToUnitSystemCategory2["PRESSURE"] = "PRESSURE";
  UnitToUnitSystemCategory2["LINEAR_PRESSURE"] = "LINEAR_PRESSURE";
  UnitToUnitSystemCategory2["LINEAR_FREQUENCY"] = "LINEAR_FREQUENCY";
  UnitToUnitSystemCategory2["ROTATIONAL_FREQUENCY"] = "ROTATIONAL_FREQUENCY";
  UnitToUnitSystemCategory2["VOLTAGE"] = "VOLTAGE";
  UnitToUnitSystemCategory2["CURRENT"] = "CURRENT";
})(UnitToUnitSystemCategory || (UnitToUnitSystemCategory = {}));
var unitToUnitSystemDefinition = {
  [UnitToUnitSystemCategory.SQUARE_AREA]: {
    [import_echain_shared_i18n.UnitSystem.metric]: AreaCode.SQUARE_MILLIMETER,
    [import_echain_shared_i18n.UnitSystem.imperial]: AreaCode.SQUARE_INCH
  },
  [UnitToUnitSystemCategory.CUBIC_AREA]: {
    [import_echain_shared_i18n.UnitSystem.metric]: AreaCode.CUBIC_MILLIMETER,
    [import_echain_shared_i18n.UnitSystem.imperial]: AreaCode.CUBIC_INCH
  },
  [UnitToUnitSystemCategory.DENSITY]: {
    [import_echain_shared_i18n.UnitSystem.metric]: DensityCode.GRAM_PER_CUBIC_CENTIMETER,
    [import_echain_shared_i18n.UnitSystem.imperial]: DensityCode.POUND_PER_CUBIC_INCH
  },
  [UnitToUnitSystemCategory.TEMPERATURE]: {
    [import_echain_shared_i18n.UnitSystem.metric]: TemperatureCode.CELSIUS,
    [import_echain_shared_i18n.UnitSystem.imperial]: TemperatureCode.FAHRENHEIT
  },
  [UnitToUnitSystemCategory.LENGTH_METER_FEET]: {
    [import_echain_shared_i18n.UnitSystem.metric]: LengthCode.METER,
    [import_echain_shared_i18n.UnitSystem.imperial]: LengthCode.FEET
  },
  [UnitToUnitSystemCategory.LENGTH_MILLIMETER_INCH]: {
    [import_echain_shared_i18n.UnitSystem.metric]: LengthCode.MILLIMETER,
    [import_echain_shared_i18n.UnitSystem.imperial]: LengthCode.INCH
  },
  [UnitToUnitSystemCategory.WEIGHT]: {
    [import_echain_shared_i18n.UnitSystem.metric]: WeightCode.KILOGRAM,
    [import_echain_shared_i18n.UnitSystem.imperial]: WeightCode.POUND
  },
  [UnitToUnitSystemCategory.WEIGHT_PER_LENGTH]: {
    [import_echain_shared_i18n.UnitSystem.metric]: WeightPerLengthCode.KILOGRAM_PER_KILOMETER,
    [import_echain_shared_i18n.UnitSystem.imperial]: WeightPerLengthCode.POUND_PER_THOUSAND_FOOT
  },
  [UnitToUnitSystemCategory.SPEED]: {
    [import_echain_shared_i18n.UnitSystem.metric]: SpeedCode.METER_PER_SECOND,
    [import_echain_shared_i18n.UnitSystem.imperial]: SpeedCode.FOOT_PER_SECOND
  },
  [UnitToUnitSystemCategory.ACCELERATION]: {
    [import_echain_shared_i18n.UnitSystem.metric]: AccelerationCode.METER_PER_SQUARE_SECOND,
    [import_echain_shared_i18n.UnitSystem.imperial]: AccelerationCode.FEET_PER_SQUARE_SECOND
  },
  [UnitToUnitSystemCategory.FORCE]: {
    [import_echain_shared_i18n.UnitSystem.metric]: ForceCode.NEWTON,
    [import_echain_shared_i18n.UnitSystem.imperial]: ForceCode.POUND_FORCE
  },
  [UnitToUnitSystemCategory.PRESSURE]: {
    [import_echain_shared_i18n.UnitSystem.metric]: PressureCode.MEGAPASCAL,
    [import_echain_shared_i18n.UnitSystem.imperial]: PressureCode.PSI
  },
  [UnitToUnitSystemCategory.LINEAR_PRESSURE]: {
    [import_echain_shared_i18n.UnitSystem.metric]: LinearPressureCode.MEGAPASCAL_PER_METER_METER_PER_SECOND,
    [import_echain_shared_i18n.UnitSystem.imperial]: LinearPressureCode.POUND_FORCE_PER_SQUARE_INCH_FOOT_PER_MINUTE
  },
  [UnitToUnitSystemCategory.LINEAR_FREQUENCY]: {
    [import_echain_shared_i18n.UnitSystem.metric]: LinearFrequencyCode.STROKES_PER_MINUTE,
    [import_echain_shared_i18n.UnitSystem.imperial]: LinearFrequencyCode.STROKES_PER_MINUTE
  },
  [UnitToUnitSystemCategory.ROTATIONAL_FREQUENCY]: {
    [import_echain_shared_i18n.UnitSystem.metric]: FrequencyCode.PER_MINUTE,
    [import_echain_shared_i18n.UnitSystem.imperial]: RotationalFrequencyCode.ROTATIONAL_REVOLUTION_PER_MINUTE
  },
  [UnitToUnitSystemCategory.VOLTAGE]: {
    [import_echain_shared_i18n.UnitSystem.metric]: VoltageCode.VOLT,
    [import_echain_shared_i18n.UnitSystem.imperial]: VoltageCode.VOLT
  },
  [UnitToUnitSystemCategory.CURRENT]: {
    [import_echain_shared_i18n.UnitSystem.metric]: CurrentCode.AMPERE,
    [import_echain_shared_i18n.UnitSystem.imperial]: CurrentCode.AMPERE
  }
};

// src/unitLabelDefinitions.ts
var unitLabels = {
  [DurationCode.MINUTE]: "min",
  [DurationCode.SECOND]: "sec",
  WATER_ABSORTION: "Wt.- %",
  [AccelerationCode.METER_PER_SQUARE_SECOND]: "m/s\xB2",
  FOOD_PER_SQUARE_SECOND: "ft/s\xB2",
  [AccelerationCode.FEET_PER_SQUARE_SECOND]: "ft/s\xB2",
  [AngleCode.RADIAN]: "rad",
  MILLIRADIAN: "mrad",
  MICRORADIAN: "\xB5rad",
  [AngleCode.DEGREE]: "\xB0",
  // TODO: This code is defined in Akeneo for both "angel" and "duration".
  // The "angel" is, after consultation with Philip, excluded from the definition
  // until there is a solution on the Akeneo side.
  // [AngleCode.MINUTE]: "'",
  // [AngleCode.SECOND]: '"',
  [AngleCode.GON]: "gon",
  [AngleCode.MIL]: "mil",
  REVOLUTION: "rev",
  RADIAN_PER_SECOND_SQUARED: "rad/s\xB2",
  DEGREE_PER_SECOND_SQUARED: "\xB0/s\xB2",
  SQUARE_MILLIMETER: "mm\xB2",
  SQUARE_CENTIMETER: "cm\xB2",
  SQUARE_DECIMETER: "dm\xB2",
  SQUARE_METER: "m\xB2",
  CENTIARE: "ca",
  SQUARE_DEKAMETER: "dam\xB2",
  ARE: "a",
  SQUARE_HECTOMETER: "hm\xB2",
  HECTARE: "ha",
  SQUARE_KILOMETER: "km\xB2",
  SQUARE_MIL: "sq mil",
  SQUARE_INCH: "in\xB2",
  SQUARE_FOOT: "ft\xB2",
  SQUARE_YARD: "yd\xB2",
  ARPENT: "arpent",
  ACRE: "A",
  SQUARE_FURLONG: "fur\xB2",
  SQUARE_MILE: "mi\xB2",
  BEND_FACTOR: "x d",
  CHAR: "char",
  KILOBIT: "kbit",
  MEGABIT: "Mbit",
  GIGABIT: "Gbit",
  BIT: "b",
  BYTE: "B",
  KILOBYTE: "kB",
  MEGABYTE: "MB",
  GIGABYTE: "GB",
  TERABYTE: "TB",
  LUMEN: "lm",
  NIT: "nits",
  ATTOFARAD: "aF",
  PICOFARAD: "pF",
  NANOFARAD: "nF",
  MICROFARAD: "\xB5F",
  MILLIFARAD: "mF",
  FARAD: "F",
  KILOFARAD: "kF",
  PIECE: "Pc",
  DOZEN: "Dz",
  DECIBEL: "dB",
  PICO_NAN_PER_KILO: "ps/nm x km",
  MILLISECOND: "ms",
  HOUR: "h",
  DAY: "d",
  WEEK: "week",
  MONTH: "month",
  YEAR: "year",
  MILLIAMPEREHOUR: "mAh",
  AMPEREHOUR: "Ah",
  MILLICOULOMB: "mC",
  CENTICOULOMB: "cC",
  DECICOULOMB: "dC",
  COULOMB: "C",
  DEKACOULOMB: "daC",
  HECTOCOULOMB: "hC",
  KILOCOULOMB: "kC",
  JOULE: "J",
  CALORIE: "cal",
  KILOCALORIE: "kcal",
  KILOJOULE: "kJ",
  MILLINEWTON: "mN",
  [ForceCode.NEWTON]: "N",
  KILONEWTON: "kN",
  MEGANEWTON: "MN",
  [ForceCode.POUND_FORCE]: "lbs",
  POUNDS: "lbs",
  NEWTON_METER_PER_AMPERE: "Nm/A",
  HERTZ: "Hz",
  KILOHERTZ: "kHz",
  MEGAHERTZ: "MHz",
  GIGAHERTZ: "GHz",
  TERAHERTZ: "THz",
  HENRY: "H",
  MILLI_HENRY: "mH",
  MILLIAMPERE: "mA",
  CENTIAMPERE: "cA",
  DECIAMPERE: "dA",
  AMPERE: "A",
  DEKAMPERE: "daA",
  HECTOAMPERE: "hA",
  KILOAMPERE: "kA",
  MICROMETER: "\u03BCm",
  NAUTICAL_MILE: "nm",
  [LengthCode.MILLIMETER]: "mm",
  CENTIMETER: "cm",
  DECIMETER: "dm",
  [LengthCode.METER]: "m",
  DEKAMETER: "dam",
  HECTOMETER: "hm",
  [LengthCode.KILOMETER]: "km",
  [LengthCode.INCH]: "in",
  [LengthCode.FEET]: "ft",
  YARD: "yd",
  CHAIN: "ch",
  FURLONG: "fur",
  MILE: "mi",
  THOUSAND_FOOT: "mft",
  DECIBEL_PER_KILOMETER: "db/km",
  JOULE_PER_KILOGRAM: "J/kg",
  MEGAHERZ_PER_KILOMETER: "MHz x km",
  KILOGRAM_PER_METER: "kg/m",
  [WeightPerLengthCode.KILOGRAM_PER_KILOMETER]: "kg/km",
  GRAM_PER_METER: "g/m",
  GRAMM_PER_METER: "g/m",
  [WeightPerLengthCode.POUND_PER_THOUSAND_FOOT]: "lbs/mft",
  KILOGRAM_PER_100MM: "kg/100 mm",
  [LinearPressureCode.MEGAPASCAL_PER_METER_METER_PER_SECOND]: "MPa x m/s",
  [LinearPressureCode.POUND_FORCE_PER_SQUARE_INCH_FOOT_PER_MINUTE]: "psi x fpm",
  MOMENT_OF_INERTIA: "kgcm\xB2",
  WATT: "W",
  KILOWATT: "kW",
  MEGAWATT: "MW",
  GIGAWATT: "GW",
  TERAWATT: "TW",
  CENTIBAR: "cbar",
  DECIBAR: "dbar",
  KILOBAR: "kbar",
  MEGABAR: "Mbar",
  KILOPASCAL: "kPa",
  [PressureCode.MEGAPASCAL]: "MPa",
  GIGAPASCAL: "GPa",
  BAR: "Bar",
  PASCAL: "Pa",
  HECTOPASCAL: "hPa",
  MILLIBAR: "mBar",
  ATM: "atm",
  [PressureCode.PSI]: "PSI",
  TORR: "Torr",
  MMHG: "mmHg",
  PERCENT: "%",
  MILLIOHM: "m\u03A9",
  CENTIOHM: "c\u03A9",
  DECIOHM: "d\u03A9",
  OHM: "\u03A9",
  DEKAOHM: "da\u03A9",
  HECTOHM: "h\u03A9",
  KILOHM: "k\u03A9",
  MEGOHM: "M\u03A9",
  [TorsionCode.DEGREE_PER_METER]: "\xB0/m",
  [TorsionCode.DEGREE_PER_FOOT]: "\xB0/ft",
  REVOLUTION_PER_SECOND: "r/s",
  REVOLUTION_PER_MINUTE: "r/min",
  ROTATIONAL_REVOLUTION_PER_MINUTE: "rpm",
  STROKES_PER_MINUTE: "spm",
  CM4: "cm\u2074",
  MM4: "mm\u2074",
  [SpeedCode.METER_PER_SECOND]: "m/s",
  METER_PER_MINUTE: "m/mn",
  METER_PER_HOUR: "m/h",
  KILOMETER_PER_HOUR: "km/h",
  [SpeedCode.FOOT_PER_SECOND]: "ft/s",
  FOOT_PER_HOUR: "ft/h",
  YARD_PER_HOUR: "yd/h",
  MILE_PER_HOUR: "mi/h",
  FOOT_PER_MINUTE: "fpm",
  MILLIMETER_PER_SECOND: "mm/s",
  [TemperatureCode.CELSIUS]: "\xB0C",
  [TemperatureCode.FAHRENHEIT]: "\xB0F",
  KELVIN: "\xB0K",
  RANKINE: "\xB0R",
  REAUMUR: "\xB0r",
  NEWTON_METER: "Nm",
  [VoltageCode.MILLIVOLT]: "mV",
  [VoltageCode.CENTIVOLT]: "cV",
  [VoltageCode.DECIVOLT]: "dV",
  [VoltageCode.VOLT]: "V",
  [VoltageCode.DEKAVOLT]: "daV",
  [VoltageCode.HECTOVOLT]: "hV",
  [VoltageCode.KILOVOLT]: "kV",
  [VoltageCode.volt_per_kilo_round_per_minute]: "V/krpm",
  VOLTAGE_CONSTANT: "V/krpm",
  MICROLITER: "\u03BCl",
  HECTOLITER: "hl",
  CUBIC_MILLIMETER: "mm\xB3",
  CUBIC_CENTIMETER: "cm\xB3",
  MILLILITER: "ml",
  CENTILITER: "cl",
  DECILITER: "dl",
  CUBIC_DECIMETER: "dm\xB3",
  LITER: "l",
  CUBIC_METER: "m\xB3",
  OUNCE: "oz",
  PINT: "pt",
  BARREL: "bbl",
  GALLON: "gal",
  CUBIC_FOOT: "ft\xB3",
  CUBIC_INCH: "in\xB3",
  CUBIC_YARD: "yd\xB3",
  CUBIC_METER_PER_SECOND: "m\xB3/s",
  CUBIC_METER_PER_MINUTE: "m\xB3/min",
  CUBIC_METER_PER_HOUR: "m\xB3/h",
  CUBIC_METER_PER_DAY: "m\xB3/d",
  MILLILITER_PER_SECOND: "ml/s",
  MILLILITER_PER_MINUTE: "ml/min",
  MILLILITER_PER_HOUR: "ml/h",
  MILLILITER_PER_DAY: "ml/d",
  CUBIC_CENTIMETER_PER_SECOND: "cm\xB3/s",
  CUBIC_CENTIMETER_PER_MINUTE: "cm\xB3/min",
  CUBIC_CENTIMETER_PER_HOUR: "cm\xB3/h",
  CUBIC_CENTIMETER_PER_DAY: "cm\xB3/d",
  CUBIC_DECIMETER_PER_MINUTE: "dm\xB3/min",
  CUBIC_DECIMETER_PER_HOUR: "dm\xB3/h",
  LITER_PER_SECOND: "l/s",
  LITER_PER_MINUTE: "l/min",
  LITER_PER_HOUR: "l/h",
  LITER_PER_DAY: "l/d",
  KILOLITER_PER_HOUR: "kl/h",
  GRAM_PER_LITER: "g/l",
  [DensityCode.GRAM_PER_CUBIC_CENTIMETER]: "g/cm\xB3",
  [DensityCode.POUND_PER_CUBIC_INCH]: "lb/in\xB3",
  MICROGRAM: "\u03BCg",
  MILLIGRAM: "mg",
  GRAM: "g",
  [WeightCode.KILOGRAM]: "kg",
  TON: "t",
  GRAIN: "gr",
  DENIER: "denier",
  ONCE: "once",
  MARC: "marc",
  LIVRE: "livre",
  [WeightCode.POUND]: "lb",
  FOOT_POUND: "lbf",
  PER_MINUTE: "1/min"
};

// src/schemaUnitCodesDefinitions.ts
var schemaUnitCodes = {
  // Weight
  [WeightCode.KILOGRAM]: "KGM",
  GRAM: "GRM",
  MILLIGRAM: "MGM",
  [WeightCode.POUND]: "LBR",
  OUNCE: "ONZ",
  TON: "TNE",
  // Length
  [LengthCode.MILLIMETER]: "MMT",
  [LengthCode.METER]: "MTR",
  [LengthCode.KILOMETER]: "KMT",
  [LengthCode.INCH]: "INH",
  [LengthCode.FEET]: "FOT",
  // Temperature
  [TemperatureCode.CELSIUS]: "CEL",
  [TemperatureCode.FAHRENHEIT]: "FAH",
  // Angle
  [AngleCode.DEGREE]: "DD",
  // Force
  [ForceCode.NEWTON]: "NEW",
  // Pressure
  [PressureCode.MEGAPASCAL]: "MPA",
  [PressureCode.PSI]: "PS",
  // Speed
  [SpeedCode.METER_PER_SECOND]: "MTS",
  // Area
  [AreaCode.SQUARE_MILLIMETER]: "MMK",
  // Acceleration
  [AccelerationCode.METER_PER_SQUARE_SECOND]: "MSK"
};

// src/utils.ts
var getFlatUnitToUnitSystemDefinition = /* @__PURE__ */ __name(() => Object.values(unitToUnitSystemDefinition), "getFlatUnitToUnitSystemDefinition");
var getUnitCodeForUnitSystem = /* @__PURE__ */ __name((unitCode, unitSystem) => {
  if (!unitSystem) {
    return unitCode;
  }
  for (const unitCategory of Object.keys(unitToUnitSystemDefinition)) {
    const unitSystemMapping = unitToUnitSystemDefinition[unitCategory];
    for (const unitCategoryUnitSystem of Object.keys(unitSystemMapping)) {
      if (unitSystemMapping[unitCategoryUnitSystem] === unitCode) {
        return unitToUnitSystemDefinition[unitCategory][unitSystem];
      }
    }
  }
  return unitCode;
}, "getUnitCodeForUnitSystem");
var getUnitLabel = /* @__PURE__ */ __name((unitCode) => unitLabels[unitCode] || "", "getUnitLabel");
var getUnitLabelForUnitSystem = /* @__PURE__ */ __name((unitCode, unitSystem) => {
  const unitCodeForUnitSystem = getUnitCodeForUnitSystem(unitCode, unitSystem);
  return getUnitLabel(unitCodeForUnitSystem);
}, "getUnitLabelForUnitSystem");
var getUnitSystemDefinitionItem = /* @__PURE__ */ __name((unitCategory) => unitToUnitSystemDefinition[unitCategory], "getUnitSystemDefinitionItem");
var getSchemaUnitCode = /* @__PURE__ */ __name((unitCode) => schemaUnitCodes[unitCode] || "", "getSchemaUnitCode");
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  AccelerationCode,
  AngleCode,
  AreaCode,
  CurrentCode,
  DensityCode,
  DurationCode,
  ForceCode,
  FrequencyCode,
  LengthCode,
  LinearFrequencyCode,
  LinearPressureCode,
  PressureCode,
  RotationalFrequencyCode,
  SpeedCode,
  TemperatureCode,
  TorsionCode,
  UnitSystem,
  UnitToUnitSystemCategory,
  WeightCode,
  WeightPerLengthCode,
  getFlatUnitToUnitSystemDefinition,
  getSchemaUnitCode,
  getUnitCodeForUnitSystem,
  getUnitLabel,
  getUnitLabelForUnitSystem,
  getUnitSystemDefinitionItem
});
